export const searchDomainIndexes = {
  bettingSplits: 'search-pbd-stats',
  eventOverview: 'event-overview',
  matchupCentre: 'search-matchup-centre',
  playerData: 'player-data',
  positiveEv: 'search-ev-bets',
  premiumMarketMovers: 'bet-insights',
  trends: 'search-trends',
} as const;

export type SearchDomainIndexName = (typeof searchDomainIndexes)[keyof typeof searchDomainIndexes];

export const bettingSplitsIndex = searchDomainIndexes.bettingSplits;
export const eventOverviewIndex = searchDomainIndexes.eventOverview;
export const matchupCentreIndex = searchDomainIndexes.matchupCentre;
export const playerDataIndex = searchDomainIndexes.playerData;
export const positiveEvIndex = searchDomainIndexes.positiveEv;
export const premiumMarketMoversIndex = searchDomainIndexes.premiumMarketMovers;
export const trendsIndex = searchDomainIndexes.trends;
